// extracted by mini-css-extract-plugin
module.exports = {"overflow-hidden-container":"adserver_overflow-hidden-container__2E2i5"};